"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Container = void 0;
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = __importDefault(require("../../theme"));
var shimmerKeyframe = styled_components_1.keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    0% {\n        background-position: -468px 0;\n    }\n    100% {\n        background-position: 468px 0;\n    }\n"], ["\n    0% {\n        background-position: -468px 0;\n    }\n    100% {\n        background-position: 468px 0;\n    }\n"])));
exports.Container = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  float: left;\n  height: ", "px;\n  width: ", "px;\n  animation: ", " 2s linear infinite forwards;\n  background: ", ";\n  background: -webkit-gradient(\n    linear,\n    left top,\n    right top,\n    color-stop(8%, ", "),\n    color-stop(18%, ", "),\n    color-stop(33%, ", ")\n  );\n  background: linear-gradient(\n    to right,\n    ", " 8%,\n    ", " 18%,\n    ", " 33%\n  );\n  background-size: 800px 100px;\n  border-radius: ", ";\n"], ["\n  float: left;\n  height: ", "px;\n  width: ", "px;\n  animation: ", " 2s linear infinite forwards;\n  background: ", ";\n  background: -webkit-gradient(\n    linear,\n    left top,\n    right top,\n    color-stop(8%, ", "),\n    color-stop(18%, ", "),\n    color-stop(33%, ", ")\n  );\n  background: linear-gradient(\n    to right,\n    ", " 8%,\n    ", " 18%,\n    ", " 33%\n  );\n  background-size: 800px 100px;\n  border-radius: ", ";\n"])), function (_a) {
    var height = _a.height;
    return height;
}, function (_a) {
    var width = _a.width;
    return width;
}, shimmerKeyframe, theme_1.default.colorsPalette.gray.lighter, theme_1.default.colorsPalette.gray.lighter, theme_1.default.colorsPalette.gray.light, theme_1.default.colorsPalette.gray.lighter, theme_1.default.colorsPalette.gray.lighter, theme_1.default.colorsPalette.gray.light, theme_1.default.colorsPalette.gray.lighter, function (_a) {
    var variant = _a.variant;
    return (variant === "circle" ? "50%" : "4px");
});
var templateObject_1, templateObject_2;
//# sourceMappingURL=styles.js.map